export default __webpack_public_path__ + "static/media/Daniel.45995bfc.jpg";